import classnames from 'classnames';
import React, { useId } from 'react';

import '@eika/radio-button-style';

import ErrorMessageLabel from './ErrorMessageLabel';
import { RadioButtonLabel } from './RadioButtonLabel';
import RadioButtonPanel from './RadioButtonPanel';
import { RadioButtonPanelProps } from './Types';

const RadioButtonPanels = ({
    className,
    selectedOption,
    options,
    onChange,
    name,
    label,
    sublabel,
    infoButton,
    externalLinkLabel,
    errorMessage,
    required = false,
    dataTrackId = label,
    children,
}: RadioButtonPanelProps): JSX.Element => {
    const errorId = useId();

    return (
        <fieldset className={classnames('sgw-radio-button-panels', className)}>
            <RadioButtonLabel
                label={label}
                sublabel={sublabel}
                infoButton={infoButton}
                externalLinkLabel={externalLinkLabel}
            />
            {!!children && <div className="sgw-radio-button-panels__children-wrapper">{children}</div>}
            {options.map(({ ref, dataTrackLinkname, ...option }) => (
                <RadioButtonPanel
                    onChange={onChange}
                    selectedOption={selectedOption}
                    inputRef={ref}
                    name={name}
                    describedBy={errorId}
                    required={required}
                    error={!!errorMessage}
                    dataTrackId={dataTrackId}
                    dataTrackLinkname={dataTrackLinkname}
                    key={option.value}
                    {...option}
                />
            ))}
            <ErrorMessageLabel errorMessage={errorMessage} errorId={errorId} />
        </fieldset>
    );
};

export default RadioButtonPanels;
